import { GlobalControlsConnections } from 'app/API.service';

export const GLOBAL_CONTROLS_TOOLTIP: string =
  'By clicking ‘Add’, all the questions you’ve flagged will automatically be copied to every entity that shares the same risk framework.';
export const GLOBAL_CONTROLS_ERROR_TOOLTIP: string =
  'Due to recent changes in the risk framework, please note it is not functioning properly.';

export const GLOBAL_CONTROLS_SUCCESS_MESSAGE: string = 'Global controls connected successfully';
export const GLOBAL_CONTROL_REMOVE_SUCCESS_MESSAGE: string = 'Global controls connection removed successfully';
export const GLOBAL_CONTROLS_ERROR_MESSAGE: string =
  'The global controls connection was unsuccessful. Please try again later.';

export const GC_SUFFIX: string = 'GLOBAL_CONTROL';

export const LOGS_DELIMITER: string = '::';

//* Global Controls
export interface _GlobalControlItem {
  id: string;
  displayName: string;
  subEntityId: string;
}

export interface GlobalControlsConnectionsExtended extends GlobalControlsConnections {
  originName: string;
  destinationName: string;
}

export interface LogEntry {
  id: string;
  action: string;
  userName: string;
  date: string;
  origin?: string;
  destination?: string;
}
